import React from "react"
import PropTypes from "prop-types"
import styled, { css } from "styled-components"

import { MfButton } from "../../components/Button"
import { MfFontIcon } from "../../foundations/FontIcon"

const CloseButtonSmall = styled(MfButton).attrs({
  text: true,
  color: "white",
})`
  padding: ${({ theme }) => theme.spacing(3)};
`

const DisplayBackButtons = styled.div`
  ${({ theme }) => css`
    ${theme.media.phone`
        .close-button {
          display: block;
        }
    `}
    ${theme.media.desktop`
        .close-button {
          display: none;
        }
    `}
  `}
`

export function CloseButton(props) {
  return (
    <DisplayBackButtons>
      <div className="close-button">
        <CloseButtonSmall {...props}>
          <MfFontIcon icon="fonticons-close-large" />
        </CloseButtonSmall>
      </div>
    </DisplayBackButtons>
  )
}

CloseButton.propTypes = {
  children: PropTypes.any,
}
